<template>
  <div v-if="approvalRequest" class="approval-status-card">
    <el-descriptions :column="3" border size="small">
      <el-descriptions-item label="결재 상태">
        <el-tag :type="statusTagType" size="default">
          {{ approvalRequest.status_display }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="기안자">
        {{ approvalRequest.requester_name }}
      </el-descriptions-item>
      <el-descriptions-item label="상신일">
        {{ formatDate(approvalRequest.submitted_at) }}
      </el-descriptions-item>
      <el-descriptions-item v-if="currentStep" label="현재 단계">
        {{ currentStep.step_name }} ({{ currentStep.approver_name }})
      </el-descriptions-item>
      <el-descriptions-item v-if="approvalRequest.completed_at" label="완료일">
        {{ formatDate(approvalRequest.completed_at) }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  approvalRequest: {
    type: Object,
    default: null,
  },
})

const statusTagType = computed(() => {
  if (!props.approvalRequest) return 'info'
  const map = {
    DRAFT: 'info',
    PENDING: 'warning',
    APPROVED: 'success',
    REJECTED: 'danger',
    CANCELLED: 'info',
  }
  return map[props.approvalRequest.status] || 'info'
})

const currentStep = computed(() => {
  return props.approvalRequest?.current_step || null
})

const formatDate = (dt) => {
  if (!dt) return '-'
  return new Date(dt).toLocaleString('ko-KR')
}
</script>

<style scoped>
.approval-status-card {
  margin-bottom: 15px;
}
</style>
